import { defineMessages } from "react-intl";
import { defaultFormMessages } from "../shared/crud/form";

export const messages = {
  ...defaultFormMessages,
  ...defineMessages({
    title: {
      id: "batchInventory.title",
      defaultMessage: "Update inventory",
    },
    accommodations: {
      id: "batchInventory.roomType",
      defaultMessage: "roomType",
    },
    occupations: {
      id: "batchInventory.settings",
      defaultMessage: "settings",
    },
    mealPlans: {
      id: "batchInventory.board",
      defaultMessage: "board",
    },
    conditions: {
      id: "batchInventory.conditions",
      defaultMessage: "conditions",
    },
    create: {
      id: "batchInventory.create",
      defaultMessage: "create",
    },
    saveSuccess: {
      id: "default.saveSuccess",
      defaultMessage: "Saved successfully",
    },
    fetchError: {
      id: "batchInventory.fetchError",
      defaultMessage:
        "Something went wrong. Please try refreshing the page in a few minutes and contact support if the issue persists",
    },
    selectAll: {
      id: "app.entityForm.selectAll",
      description: "Select all",
      defaultMessage: "Select all",
    },
    selectNone: {
      id: "app.entityForm.selectNone",
      description: "Select none",
      defaultMessage: "Select none",
    },
    adults: {
      id: "default.adult",
      description: "Adult",
      defaultMessage: "Adult",
    },
    children: {
      id: "default.child",
      description: "Child",
      defaultMessage: "Child",
    },
    babies: {
      id: "default.baby",
      description: "Baby",
      defaultMessage: "Baby",
    },
    juniors: {
      id: "default.junior",
      description: "Junior",
      defaultMessage: "Junior",
    },
    seniors: {
      id: "default.senior",
      description: "Senior",
      defaultMessage: "Senior",
    },
    guests: {
      id: "default.guests",
      description: "Guests",
      defaultMessage: "Guests",
    },
  }),
};
